import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';
import { resolveEnvironment } from './app/configs/load-runtime-config';
import { initSentry } from './app/configs/sentry-config';

/**
 * Surfaces the shared `#render-error` panel on bootstrap failure, passing a
 * human-readable reason when the cause is a failed runtime config load. Falls back
 * to the console if the handler is unavailable (e.g. under tests).
 */
function showBootstrapError(err: unknown): void {
  const error = err instanceof Error ? err : new Error(String(err));
  const reason = error.message.includes('/config.json')
    ? "We couldn't load the application's configuration. Please refresh the page; if the problem continues, follow the steps below."
    : undefined;
  const showRenderError = (window as Window & { showPreRenderError?: (e: Error, message?: string) => void })
    .showPreRenderError;
  if (typeof showRenderError === 'function') {
    showRenderError(error, reason);
  } else {
    console.error(error);
  }
}

resolveEnvironment()
  .then(environment => {
    initSentry(environment);
    return bootstrapApplication(AppComponent, createAppConfig(environment));
  })
  .catch(showBootstrapError);
